import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainTabBasePathEnum } from '../enums/main-tabs';
import { AffordabilityPageModule } from '../misc/pages/affordability/affordability.module';
import { AmortizationPageModule } from '../misc/pages/amortization/amortization.module';
import { ChangePasswordPageModule } from '../misc/pages/change-password/change-password.module';
import { PITIPageModule } from '../misc/pages/piti/piti.module';
import { ShareContactInfoPageModule } from '../misc/pages/share-contact-info/share-contact-info.module';
import { StorePageRoutingModule } from '../misc/pages/store/store-routing.module';
import { TermsPageModule } from '../misc/pages/terms/terms.module';
import { DebugPageModule } from './debug/debug.module';
import { FarmAlertsPageModule } from './farm-alerts/farm-alerts.module';
import { HomePageModule } from './home/home.module';
import { LoginCredentialsPageModule } from './login-credentials/login-credentials.module';
import { PermissionsPageModule } from './permissions/permissions.module';
import { PersonalDetailsPageModule } from './personal-details/personal-details.module';

const routes: Routes = [
  {
    loadChildren: () => HomePageModule,
    path: ''
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.More
    },
    loadChildren: () => PITIPageModule,
    path: 'calculators/piti'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.More
    },
    loadChildren: () => AmortizationPageModule,
    path: 'calculators/amortization'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.More
    },
    loadChildren: () => AffordabilityPageModule,
    path: 'calculators/affordability'
  },
  {
    loadChildren: () => ShareContactInfoPageModule,
    path: 'share-contact-info'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.More
    },
    loadChildren: () => StorePageRoutingModule,
    path: 'store'
  },
  {
    loadChildren: () => PersonalDetailsPageModule,
    path: 'personal-details'
  },
  {
    loadChildren: () => LoginCredentialsPageModule,
    path: 'login-credentials'
  },
  {
    data: {
      isPasswordExpired: false
    },
    loadChildren: () => ChangePasswordPageModule,
    path: 'login-credentials/change-password'
  },
  {
    loadChildren: () => FarmAlertsPageModule,
    path: 'farm-alerts'
  },
  {
    data: {
      isOnboardingFlow: false
    },
    loadChildren: () => TermsPageModule,
    path: 'terms'
  },
  {
    loadChildren: () => PermissionsPageModule,
    path: 'permissions'
  },
  {
    loadChildren: () => DebugPageModule,
    path: 'debug'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class MoreRoutingModule {}
